/** @jsxImportSource @emotion/react */

import { Tabs, TabsProps } from "antd";
import HelmetCustom from "components/ui/Helmet";
import { HeaderUser } from "components/ui/user/HeaderUser";
import { UserWrapperPage } from "components/ui/user/UserWrapperPage";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { Deposit } from "./Deposit";
import { TradingPageStyle } from "./index.style";
import { Withdraw } from "./Withdraw";

const TradingPage = () => {
  const { t } = useTranslation("trading");
  const [searchParams, setSearchParams] = useSearchParams();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("Deposit"),
      children: <Deposit />
    },
    {
      key: "2",
      label: t("Withdrawal"),
      children: <Withdraw />
    }
  ];
  return (
    <UserWrapperPage>
      <HeaderUser title={t("titlePage")} />
      <HelmetCustom title={t("titlePage")} />
      <div css={TradingPageStyle.tab}>
        <Tabs
          key={searchParams.get("type")}
          activeKey={searchParams.get("type") || "1"}
          items={items}
          onChange={(e) => setSearchParams({ type: e }, { replace: true })}
        />
      </div>
    </UserWrapperPage>
  );
};

export default TradingPage;
